import { Action, combineReducers } from '@ngrx/store';
import * as fromDeletedOrders from './deleted-orders.reducer';

export const featureKey = 'deletedOrders';

export interface DeletedOrdersState {
  [fromDeletedOrders.featureKey]: fromDeletedOrders.State;
}
export function reducers(state: DeletedOrdersState, action: Action): DeletedOrdersState {
  return combineReducers({
    [fromDeletedOrders.featureKey]: fromDeletedOrders.reducer,
  })(state, action);
}
